<!-- 基地 地图 -->
<style lang="stylus" scoped>
.amap-demo {
  width: 100%;
  height: 100%;
}
</style>
<template>
  <el-amap vid="amapDemo" ref="map" :zoom="zoom" :center="center" class="amap-demo" :plugin="plugin" :amap-manager="amapManager" :events="events"></el-amap>
</template>

<script>
import weatherIcon from '../../../../static/img/base/weather-icon.png'
import monitorIcon from '../../../../static/img/base/monitor-icon.png'
import icon from '../../../../static/img/base/icon.png'
import icon0 from '../../../../static/img/base/icon0.png'
import Vue from 'vue'
import VueAMap from 'src/amap.js';
Vue.use(VueAMap);
VueAMap.initAMapApiLoader({
  key: '12fea8c7f7f0ec1a0a851b89feaf84ea',
  plugin: ['AMap.Autocomplete', 'AMap.PlaceSearch', 'AMap.Scale', 'AMap.OverView', 'AMap.ToolBar', 'AMap.MapType', 'AMap.CircleEditor', 'AMap.MouseTool', 'AMap.Polygon', 'AMap.Marker']
});
let amapManager = new VueAMap.AMapManager();
const path = [
  [106.948887, 23.76081],
  [107.030254, 23.816729],
  [107.107502, 23.692606],
  [106.996952, 23.691349],
  [106.989742, 23.730641],
  [106.948887, 23.76081]
]
const markers = [
  { point: [106.96262, 23.752012], src: weatherIcon, index: 1 },
  { point: [107.001758, 23.767094], src: monitorIcon, index: 0 },
  { point: [106.986309, 23.756097], src: icon, index: 3 },
  { point: [107.019611, 23.730327], src: icon0, index: 2 }
];
const list = {
  '106.96262, 23.752012': 1,
  '107.001758, 23.767094': 0,
  '106.986309, 23.756097': 3,
  '107.019611, 23.730327': 2
}
export default {
  name: 'index',
  props: {
    activeItem: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      amapManager,
      zoom: 12,
      center: [107.0156629745, 23.7356699750],
      plugin: [],
      events: {
        init: o => {
          this.map = this.$refs.map.$$getInstance();
          const AMap = window.AMap;
          if (AMap) {
            // var mouseTool = new AMap.MouseTool(this.map);
            // this.mouseTool = mouseTool;
          }
        },
        complete: o => {
          var RoadNet = new AMap.TileLayer.Satellite();
          this.map.add([RoadNet]);
          // 画区域图
          var polyline = new AMap.Polygon({
            path: path,
            isOutline: true,
            outlineColor: '#ffeeff',
            borderWeight: 1,
            strokeColor: "rgb(0,255,255)",
            strokeOpacity: 0.8,
            strokeWeight: 6,
            fillColor: 'rgba(0,168,255,.8)',
            // 折线样式还支持 'dashed'
            strokeStyle: "solid",
            // strokeStyle是dashed时有效
            strokeDasharray: [10, 5],
            lineJoin: 'round',
            lineCap: 'round',
            zIndex: 50
          })
          polyline.setMap(this.map)
          const that = this;
          polyline.on('click', function (e) {
            console.log(e.lnglat.getLng())
            console.log(e.lnglat.getLat())
          });
          // 标记点
          for (let i in markers) {
            const icon = new AMap.Icon({
              size: new AMap.Size(40, 40),
              imageSize: new AMap.Size(40, 40),
              image: markers[i].src
            });
            const marker = new AMap.Marker({
              position: new AMap.LngLat(markers[i].point[0], markers[i].point[1]),
              cursor: 'pointer',
              icon: icon,
              extData: markers[i]
            });
            marker.on('click', function () {
              that.$emit('indexChange', marker.getExtData().index)
            });
            this.map.add(marker);
          }
        }
      }
    };
  },
  methods: {
  }
}
</script>



// WEBPACK FOOTER //
// index.vue?c2049b28